"use client";

import { useEffect } from "react";

import { useAuth } from "@/context/AuthContext";
import { usePortal } from "@/context/PortalContext";

export default function PortalMembershipBootstrap() {
  const portal = usePortal();
  const { user } = useAuth();

  useEffect(() => {
    if (!portal?.id || portal.unavailable || !user?.uid) return;

    const key = `portal-membership:${portal.id}:${user.uid}:${portal.revisionId}`;
    if (sessionStorage.getItem(key) === "complete") return;

    let cancelled = false;
    user
      .getIdToken()
      .then((idToken) =>
        fetch("/api/portal/membership", {
          method: "POST",
          headers: { Authorization: `Bearer ${idToken}` },
        })
      )
      .then(async (response) => {
        const body = await response.json().catch(() => ({}));
        if (!response.ok || body.ok === false) {
          throw new Error(body.error || "Portal enrollment failed.");
        }
        if (!cancelled) sessionStorage.setItem(key, "complete");
      })
      .catch((error) => {
        if (!cancelled) console.error("[publisher-portal] membership bootstrap failed", error);
      });

    return () => {
      cancelled = true;
    };
  }, [portal?.id, portal?.revisionId, portal?.unavailable, user]);

  return null;
}
